const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if (((context.has(`step`) ? context.get(`step`) : null) < 0)) {
                    this.echo(`  `);
                    context.proxy[`step`] = (`n` + this.env.getFilter('abs').traceableCallable(2, this.source)(...[(context.has(`step`) ? context.get(`step`) : null)]));
                }
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`, `65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`, 5, 109), new Map([[`class`, ((`demo-u-` + (context.has(`name`) ? context.get(`name`) : null)) + `-directions`)]]), true, false, 5));
            }

            getTemplateName() {
                return `65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`, ``);
            }
        }],
        [109, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`, 5);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(new Map([[0, ``], [1, `-block`], [2, `-block-start`], [3, `-block-end`], [4, `-inline`], [5, `-inline-start`], [6, `-inline-end`]]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`direction`] = __value__;
                    this.echo(`      `);
                    context.proxy[`class`] = ((((`u-` + (context.has(`name`) ? context.get(`name`) : null)) + context.get(`direction`)) + `-`) + (context.has(`step`) ? context.get(`step`) : null));
                    this.echo(`      `);
                    if (this.compare((context.has(`name`) ? context.get(`name`) : null), `pad`)) {
                        this.echo(`        <div class="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(12, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                        this.echo(`">
          <div>`);
                        this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                        this.echo(`</div>
        </div>
      `);
                    }
                    else {
                        this.echo(`        <div>
          <div class="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                        this.echo(`">`);
                        this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                        this.echo(`</div>
        </div>
      `);
                    }
                    this.echo(`    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('direction');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37');

let template = env.loadTemplate('65ce8879b99f83fb355c43bf0c42396a5c1e900988c0048d5df126689e58bb37');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/spacing/demo/directions.twig", args: context }
     );
     return rendered;;
};